/**
 * PortfolioSummaryPanel — Placeholder for the project portfolio summary.
 *
 * Occupies the right-hand pane of the resizable split view when no
 * project or group is selected. This is a holding page that will
 * eventually display aggregated portfolio metrics, collection-level
 * KPI roll-ups, risk heat maps, and other portfolio-manager views.
 *
 * The panel receives no props today but will later accept the active
 * collection GUID and filtered project data for roll-up calculations.
 */

import React from 'react';
import { useAppTranslation } from '../../i18n/useAppTranslation';
import styles from './PortfolioSummaryPanel.module.css';

export default function PortfolioSummaryPanel() {
  const { t } = useAppTranslation('pages');

  return (
    <div className={styles.container}>
      <div className={styles.inner}>
        {/* Icon */}
        <svg
          className={styles.icon}
          width="56"
          height="56"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <rect x="2" y="7" width="20" height="14" rx="2" ry="2" />
          <path d="M16 7V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v2" />
          <line x1="12" y1="12" x2="12" y2="16" />
          <line x1="10" y1="14" x2="14" y2="14" />
        </svg>

        {/* Title */}
        <h2 className={styles.title}>
          {t('portfolioSummary.title')}
        </h2>

        {/* Description */}
        <p className={styles.description}>
          {t('portfolioSummary.description')}
        </p>

        {/* Hint */}
        <p className={styles.hint}>
          {t('portfolioSummary.hint')}
        </p>
      </div>
    </div>
  );
}
